import { render, staticRenderFns } from "./SnackBar.vue?vue&type=template&id=397f7d24&scoped=true"
import script from "./SnackBar.vue?vue&type=script&lang=ts"
export * from "./SnackBar.vue?vue&type=script&lang=ts"
import style0 from "./SnackBar.vue?vue&type=style&index=0&id=397f7d24&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397f7d24",
  null
  
)

export default component.exports